<template>
  <div>
    <el-card class="upload-pop">
      <div slot="header"
           class="clearfix">
        <span>上传文件</span>
      </div>
      <el-form 
        label-position="right"
        :model="uploadData"
        status-icon
        label-width="100px"
        class="demo-ruleForm"
        :rules="rules"
        ref="uploadData"
      >
        <el-form-item label="文件选择:">
          <el-upload 
            :multiple="true"
            ref="upload"
            action=""
            :on-change="handleFileChange"
            :auto-upload="false"
            :on-remove="handleRemove"
            :http-request="handleUpload"
            :file-list="uploadFilesList"
          >
            <el-button class="file-btn">文件选择</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input type="textarea" :rows="3" v-model="remark"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="mini" :disabled="upStatus"
                  @click="startUpload()">{{upStatus? '上传中' : '上传'}}</el-button>
      <el-button size="mini" @click="cancleUpload()">取消</el-button>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
import { mapMutations } from 'vuex'
export default {
  name: 'upload',
  props: {
    modalInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      uploadData: {
        // 上传数据
        area: '',
        createUser: JSON.parse(localStorage.user).account,
        device: null,
        types: null,
        describe: null,
        file: null,
        fileCode: ''
      },
      upStatus: false,
      rules: {
        area: [
          {
            required: true,
            message: '请选择区域',
            trigger: 'change'
          }
        ],
        device: [
          {
            required: true,
            message: '请选择设备',
            trigger: 'change'
          }
        ],
        types: [
          {
            required: true,
            type: 'number',
            message: '请选择分类',
            trigger: 'change'
          }
        ],
        describe: [
          {
            required: true,
            message: '请填写描述',
            trigger: 'blur'
          }
        ]
      },
      file: null, // 文件
      fileList: [], // 
      params: {},
      remark: '',
      uploadFilesList: [],
      uploadFileList: []
    }
  },
  created() {
    console.log(this.modalInfo)
    this.upStatus = false
  },
  methods: {
    ...mapMutations(['showModal', 'closeModal']),
    // 移除文件
    handleRemove(file, fileList) {
      console.log('移除文件', fileList)
    },
    // 取消&关闭上传
    cancleUpload() {
      this.closeModal('upload')
      this.uploadData = {
        area: null,
        createUser: JSON.parse(localStorage.user).account,
        device: null,
        types: null,
        describe: null
      }
    },
    handleUpload() {
      this.uploadFilesList.forEach(n => {
        let params = new FormData()
        params.append('userID', '')
        params.append('modifier', this.modalInfo.fileCreater ? this.modalInfo.fileCreater : JSON.parse(localStorage.user).userId)
        params.append('creator', this.modalInfo.fileCreater ? this.modalInfo.fileCreater : JSON.parse(localStorage.user).userId)
        params.append('ParentID', String(this.modalInfo.id))
        params.append('remark', this.remark)
        params.append('formfile', n.raw)
        ApiService.person_doc.addPersonDoc(params).then(res => {
          if (res.code === 0) {
            this.$store.commit('reloadFile', Math.random())
            this.closeModal('upload')
            this.passShow = true
            this.uploadData = {
              area: null,
              createUser: JSON.parse(localStorage.user).account,
              device: null,
              types: null,
              describe: null
            }
            this.$message({
              message: '上传成功',
              type: 'success'
            })
            this.upStatus = false
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        })
      })
    },
    startUpload() {
      this.upStatus = true
      // this.$refs.upload.submit()
      this.handleUpload()
    },
    // 控制选择文件按钮
    handleFileChange(file, fileList) {
      console.log(file)
      console.log(fileList)
      this.uploadFile = file
      this.uploadFilesList = fileList
    },
    handleChange() {
      console.log(this.uploadData.fileCode)
    }
  }
}
</script>
<style lang="scss">
@import '../../common/css/color.scss';
.upload-pop {
  width: 580px;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
  .el-card__body {
    padding: 30px 40px;
    .el-form {
      .el-textarea__inner {
        resize: none;
        height: 50px;
        border-radius: 2px;
      }

      .file-btn {
        display: block;
        width: 80px;
        height: 32px;
        line-height: 32px;
        padding: 0;
        color: #999;
        font-size: 14px;
      }

      .el-upload {
        display: block;
      }
      .el-upload-list {
        max-height: 200px;
        overflow: auto;
        margin-top: 10px;
        border: 1px solid rgba(0, 0, 0, 0.2);
      }
      .el-upload-list__item:first-child {
        margin-top: 0px;
      }

      .el-upload-list__item-name {
        display: flex;
      }

      .el-upload__input {
        display: none;
      }

      .el-form-item {
        margin-bottom: 16px;

        .el-form-item__label {
          line-height: 32px;
        }
        .el-form-item__content {
          width: 360px;
          .el-cascader {
            display: block;
          }
        }
      }
    }
  }
}
.el-cascader-panel {
  .el-scrollbar__wrap {
    overflow: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/upload.vue